import React from 'react';
import UploadForm from './Components/UploadForm';


const AdminDashboard = () => {
  return (
    <div className="p-6 mt-24">
      <h1 className="text-2xl text-center font-bold mb-4">Admin Panel</h1>
      <UploadForm />
    
    </div>
  );
};

export default AdminDashboard;
